import axios from 'axios';

const host = process.env.VUE_APP_URL_API;

export default class Payment {
  doPayment(programId, data) {
    if (!data.installments) {
      // eslint-disable-next-line no-param-reassign
      delete data.installments;
    }
    this.path = `/checkout/${programId}/payment`;
    this.url = host + this.path;
    return axios.post(this.url, data);
  }
}
